/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td

const timeDate = require ('../../../../../js-handler/time-date')
const formats = require('../../../../../js-handler/math')

export const tableDetail = {
    entity: 'transaction',//name table on the db
    dest: 'transaction',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail:`data-detail='{ "click": [ {"dest":"ripple" } ],
                                
                                 "clickRight": [{"dest":"transaction", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"transaction", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields : ["transaction.entity_name","accounts.name"],
        mainFilterValues : ["", ""],         
        andFilterFields  : [""],
        andFilterValues  : [""],  
    }
}

/****************ELEMENTS*****************/

//each element could organize their data diferent
export function organizeRow(data){ 
    
    //console.log('organizeRow>')

    var newData = []

    if(data.length === 0){
        newData.push({   id: 'nothing', colum: [{ label:'No Results', span: ''},
                                                { label:'', span: '' }, 
                                                { label:'', span: '' },
                                                { label:'', span: '' },
                                                { label:'', span: '' }] })
        return newData
    }

    data.forEach((elem) => {
        const sides = getTransactionSides(elem)
        newData.push({
            id: elem.id,
            trDetail: `data-transaction-entity="${escapeTransactionText(elem.entity)}" data-transaction-record="${escapeTransactionText(elem.entity_id)}"`,
            tdDataDetail: movementDetail(elem),
            colum: [
                { label: escapeTransactionText(getTransactionEntityName(elem.entity)), span: escapeTransactionText(elem.code) },
                transactionAccountCell(sides.from),
                transactionAccountCell(sides.to),
                { label: elem.transactionAmount, span: escapeTransactionText(elem.payment_method?.trim() || 'N/A') },
                { label: getTransactionStatus(elem), span: getTransactionDateTime(elem) },
            ],
        })
    })

    return newData
}/*organizeRow*/

// Nombres visibles de las entidades que generan movimientos en Transaction.
export function getTransactionEntityName(entity) {
    switch (entity) {
        case 'account_transfer':
            return 'Transfer Between Accounts'
        case 'asset_disposal':
            return 'Asset Disposal'
        case 'asset_purchase':
            return 'Purchase Fixed Asset'
        case 'bank_fees':
            return 'Bank Fees'
        case 'bounced_check':
            return 'Bounced Check'
        case 'card_payment':
            return 'Credit Card Payment'
        case 'depreciation':
            return 'Depreciation'
        case 'employesspayment':
            return 'Employee Payment'
        case 'equity_deposit':
            return 'Equity Deposit'
        case 'equity_withdrawal':
            return 'Equity Withdrawal'
        case 'loan_issued':
            return 'Loan Issued'
        case 'loan_issued_payment':
            return 'Loan Issued Payment'
        case 'loan_payment':
            return 'Loan Payment'
        case 'loan_received':
            return 'Loan Received'
        case 'operating_expense':
            return 'Operating Expense'
        case 'other_income':
            return 'Other Income'
        case 'other_receivable':
            return 'Other Receivable'
        case 'otherexpense':
            return 'Other Expense'
        case 'receivepayment':
            return 'Receive Payment'
        case 'sentpayment':
            return 'Sent Payment'
        default:
            return entity || '-'
    }
}

export function escapeTransactionText(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
}

export function getTransactionSides(row) {
    const movements = typeof row.movements === 'string' ? JSON.parse(row.movements) : (row.movements || [])
    const balances = new Map()
    const from = new Map()
    const to = new Map()
    // El query ordena los movimientos por ID: se conserva el ultimo saldo de cada cuenta.
    movements.forEach((movement) => {
        const key = String(movement.account)
        balances.set(key, movement.balance_after)
        const side = movement.action === 'out' ? from : movement.action === 'in' ? to : null
        if (side) side.set(key, movement.name || `Account #${key}`)
    })
    const entries = (side) => [...side].map(([key, name]) => {
        const balance = balances.get(key)
        return { name, balance: balance === null || balance === undefined || balance === ''
            ? '-' : formats.cashFormat(balance, true) }
    })
    return {
        from: row.entity === 'receivepayment'
            ? [{ name: 'Account Receivable', balance: '-' }] : entries(from),
        to: row.entity === 'sentpayment'
            ? [{ name: 'Account Paylable', balance: '-' }] : entries(to),
    }
}

function transactionAccountCell(accounts) {
    if (accounts.length === 0) return { label: '-', span: '-' }
    return {
        label: accounts.map((account) => escapeTransactionText(account.name)).join(' / '),
        span: accounts.map((account) => escapeTransactionText(account.balance)).join(' / '),
        style: { title: escapeTransactionText(accounts.map((account) => `${account.name}: ${account.balance}`).join(' | ')) },
    }
}

function getTransactionDateTime(row) {
    const date = String(row.date || '').slice(0, 10)
    if (!date || date === '0000-00-00') return '-'

    // Interpretar la fecha como local para evitar que YYYY-MM-DD retroceda un dia por UTC.
    const shortDate = timeDate.getdateshort(`${date}T00:00:00`)
    const time = row.date_time ? timeDate.friendlyTime(row.date_time) : ''
    return `${shortDate} ${time}`.trim()
}

// Mixed indica que los movimientos de la operacion tienen estados diferentes.
function getTransactionStatus(row) {
    const status = row.status || 'pending'
    return status.charAt(0).toUpperCase() + status.slice(1)
}

// Las subentidades con consulta implementada abren su propio formulario desde cualquier movimiento.
function movementDetail(row) {
    if (!['account_transfer', 'asset_disposal', 'bounced_check', 'bank_fees', 'card_payment', 'depreciation', 'equity_deposit', 'equity_withdrawal', 'loan_issued', 'loan_issued_payment', 'loan_payment', 'loan_received', 'operating_expense', 'other_income', 'other_receivable', 'asset_purchase'].includes(row.entity)) return undefined

    const id = String(row.id)
    if (!/^[1-9][0-9]*$/.test(id)) return undefined

    return `data-detail='{"click":[
        {"dest":"ripple"},
        {"dest":"transaction","elem":"fullcont","act":"selectOne","id":"transaction-fullcont","dbid":"${id}","transactionType":"${row.entity}"}
    ],"clickRight":[
        {"dest":"transaction","elem":"dt","act":"trMenu","id":"trMenu","entity":"transaction","dbid":"${id}"}
    ]}'`
}
